import { AppDispatch } from "..";
import { eventsActions } from "../slices/EventSlice";
import Event, { SelectedService } from "../../ts/models/Event";
import { fetchProducts } from "../../services/masters";
import { ServiceAndProducts } from "../../ts/types";
import { store } from "../";
import Product from "../../ts/models/Products";

export const setCurrEvent = (
  event: Event,
  selectedDate: number,
  availableServices: SelectedService[]
) => {
  return async (dispatch: AppDispatch) => {
    try {
      // Fetch all products for the event.
      const allProductIds: string[] = [];
      availableServices.forEach((service: SelectedService) => {
        if (service.productIds) {
          allProductIds.push(...service.productIds);
        }
      });

      const serviceProductList: ServiceAndProducts[] = [];
      if (allProductIds?.length) {
        const prodRes = await fetchProducts(allProductIds);
        for (let i = 0; i < availableServices.length; i++) {
          const serviceId = availableServices[i].serviceId;
          const productIds = availableServices[i].productIds || [];

          const service = store
            .getState()
            .masters.services.find((service) => service.id === serviceId);
          const products: Product[] = [];
          for (let j = 0; j < productIds.length; j++) {
            const prod: Product = prodRes.data.find(
              (prod: Product) => prod.id === productIds[j]
            );
            if (prod) {
              products.push(prod);
            }
          }
          if (service) {
            const data: ServiceAndProducts = {
              service,
              products,
            };
            serviceProductList.push(data);
          }
        }
      }
      dispatch(
        eventsActions.setCurrEvent({
          event,
          serviceProductList,
          selectedDate,
        })
      );
    } catch (error) {
      console.log(error);
    }
  };
};
